<template>
    <button @click="openHelpModal()" type="button" class="pppp-help-btn bg-primary text-white" data-bs-toggle="modal" data-bs-target="#helpModal">
        ?
        <span class="visually-hidden">Help</span>
    </button>
</template>

<script>
export default {
    name: 'HelpButton',
    props: {
        id:  String,
        title: String
    },
    methods: {
        openHelpModal() {
            this.$emitter.emit('openHelpModal', {id: this.id, title: this.title});
        }
    }
}
</script>

<style scoped>
.pppp-help-btn {
    width: 20px;
    height: 20px;
    padding: 0;
    border: none;
    border-radius: 50%;
    float: right;
}
</style>
